export default class ReportDefinitionModel {
  id;

  name;

  type;

  categoryGroup;

  reportCategory;

  reportDirections;

  locationType;

  productTypes;

  periodSelection;

  dataProvider;

  dataFunction;

  selectionCriteria;

  dataTransformer;

  emailOnly;

  constructor(
    id,
    type,
    categoryGroup,
    reportCategory,
    reportDirections,
    locationType,
    productTypes,
    periodSelection,
    selectionCriteria,
    dataProvider,
    dataTransformer = (data) => data,
    emailOnly = false
  ) {
    this.id = id;
    this.type = type;
    this.categoryGroup = categoryGroup;
    this.reportCategory = reportCategory;
    this.reportDirections = reportDirections;
    this.locationType = locationType;
    this.productTypes = productTypes;
    this.periodSelection = periodSelection;
    this.selectionCriteria = selectionCriteria;
    this.dataProvider = dataProvider;
    this.dataFunction = (state) => state.reporting[this.id].data;
    this.dataTransformer = dataTransformer;
    this.emailOnly = emailOnly;
  }

  getDataFunction = () => this.dataFunction;
}
